var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortableTable',{attrs:{"rows":_vm.computedResources,"headers":_vm.resourceHeaders,"table-actions":false,"row-actions":false,"key-field":"tableKey","default-sort-by":"state","paged":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }